<template>
  <section>
    <qx-search-box
      class="searchBox"
      ref="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery
    />
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        vehicleClassOptions: [],
        rechargeStateOptions: [],
        xx1Options: [],
        form: [
          {
            label: '',
            value: 'rechargeState',
            type: 'radio',
            default: -1,
            class: 'especial-radio-group',
            normalFormNotCount: true,
            onChangeRadio: () => {
              this.$refs.searchBox.sub();
            },
          },
          { // 充值类型
            label: '充值类型',
            value: 'isParent',
            type: 'select',
            placeholder: '请输入充值类型',
            default: -1,
            options: [
              { label: '全部', value: -1 },
              { label: '子卡充值', value: 0 },
              { label: '主卡充值', value: 1 },
            ],
          },
          { // 订单号
            label: '订单号',
            value: 'orderId',
            type: 'input',
            placeholder: '请输入订单号',
          },
          { // 车牌号码
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          { // 司机姓名
            label: '司机姓名',
            value: 'carDriverMan',
            type: 'input',
            placeholder: '请输入司机姓名',
          },
          { // 司机手机号
            label: '司机手机号',
            value: 'carDriverPhone',
            type: 'input',
            placeholder: '请输入司机手机号',
          },
          { // 线路名称
            label: '线路名称',
            value: 'sourceName',
            type: 'input',
            placeholder: '请输入线路名称',
          },
          { // 客户名称
            label: '客户名称',
            value: 'customName',
            type: 'input',
            placeholder: '请输入客户名称',
          },
          // { // 充值状态
          //   label: '充值状态',
          //   value: 'rechargeState',
          //   type: 'select',
          //   default: -1,
          //   placeholder: '请输入充值状态',
          // },
          { // 核销时间
            label: '核销时间',
            value: 'Time',
            type: 'date',
            default: [],
            placeholder: '请选择核销时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 车辆种类
            label: '车辆种类',
            value: 'vehicleClass',
            type: 'select',
            default: -1,
            placeholder: '请选择车辆种类',
          },
        ],
      },
    };
  },
  watch: {
    '$route.query.busiCode': function (newVal) {
      if (this.$route.path === '/manage/service/oil/oilcardRecharge') {
        this.$refs.searchBox.setVal('busiCode', newVal);
        this.$refs.searchBox.sub();
      }
    },
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      if (searchBoxData.sourceRegion) { // 运输起点
        searchBoxData.sourceRegion = searchBoxData.sourceRegion[searchBoxData.sourceRegion.length - 1];
      }
      if (searchBoxData.desRegion) { // 运输终点
        searchBoxData.desRegion = searchBoxData.desRegion[searchBoxData.desRegion.length - 1];
      }
      if (searchBoxData.Time && searchBoxData.Time[0]) { // 核销时间
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1]);
      }
      delete searchBoxData.Time;
      this.$refs.tableBox.saveSearchBoxData({
        cardCategory: this.$route.path.includes('gasCard') ? 2 : 1,
        ...searchBoxData,
      });
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'OIL_ENTITY_RECHARGE_STATE,VEHICLE_CLASS',
    });
    this.searchBoxData.rechargeStateOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[0],
    ];
    this.searchBoxData.vehicleClassOptions = [
      {
        label: '全部',
        value: -1,
      },
      ...enumsList[1],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
